module.exports = __webpack_public_path__ + "img/271.6305d87f.jpg";